/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class OAuthFlow extends ExtensibleNode {
    public authorizationUrl : string;

    public tokenUrl : string;

    public refreshUrl : string;

    public scopes : any;

    public constructor() {
        super();
        if(this.authorizationUrl===undefined) this.authorizationUrl = null;
        if(this.tokenUrl===undefined) this.tokenUrl = null;
        if(this.refreshUrl===undefined) this.refreshUrl = null;
        if(this.scopes===undefined) this.scopes = null;
    }

    /**
     * Adds a scope.
     * @param {string} scope
     * @param {string} description
     */
    public addScope(scope : string, description : string) {
        if(this.scopes == null) {
            this.scopes = <any>({});
        }
        /* put */(this.scopes[scope] = description);
    }

    /**
     * Removes a scope.
     * @param {string} scope
     */
    public removeScope(scope : string) {
        if(this.scopes != null) {
            /* remove */(map => { let deleted = this.scopes[scope];delete this.scopes[scope];return deleted;})(this.scopes);
        }
    }

    /**
     * Gets the list of scopes.
     * @return {string[]}
     */
    public getScopes() : Array<string> {
        let rval : Array<string> = <any>([]);
        if(this.scopes != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.scopes));
        }
        return rval;
    }
}
OAuthFlow["__class"] = "io.apicurio.datamodels.core.models.common.OAuthFlow";
OAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




